import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import navIconHelper from "../../helpers/navIconHelper";

interface NavIconProps {
  icon: IconDefinition;
  isSelected: boolean;
}

/** Light icon normally; the solid version, in the client's primary, when selected. */
function NavIcon({ icon, isSelected }: NavIconProps) {
  return (
    <FontAwesomeIcon
      icon={isSelected ? navIconHelper.getSelectedIcon(icon) : icon}
      size="lg"
      className="fa-fw navigation-icon"
    />
  );
}

export default NavIcon;
